import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@lumis.app");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("lumis_admin_token");
    if (token) navigate("/admin/dashboard", { replace: true });
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem("lumis_admin_token", res.data.token);
      navigate("/admin/dashboard", { replace: true });
    } catch {
      setError("Email ou senha incorretos");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#EEF2FF] flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm lumis-fade">
        <div className="text-center mb-10 space-y-2">
          <div className="text-5xl text-[#1E3A8A] font-outfit font-light">✦</div>
          <h1 className="text-2xl font-outfit font-light text-gray-900">Lumis Admin</h1>
          <p className="text-gray-500 text-sm font-manrope">Painel de Administração</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="block text-gray-500 text-xs font-manrope mb-2 uppercase tracking-widest">Email</label>
            <input
              data-testid="admin-email-input"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="w-full bg-white text-gray-900 border border-gray-300 rounded-2xl px-5 py-3.5 focus:border-[#1E3A8A]/60 focus:ring-1 focus:ring-[#1E3A8A]/30 outline-none transition-all font-manrope text-sm"
            />
          </div>
          <div>
            <label className="block text-gray-500 text-xs font-manrope mb-2 uppercase tracking-widest">Senha</label>
            <input
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="w-full bg-white text-gray-900 border border-gray-300 rounded-2xl px-5 py-3.5 focus:border-[#1E3A8A]/60 focus:ring-1 focus:ring-[#1E3A8A]/30 outline-none transition-all font-manrope text-sm"
            />
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 rounded-2xl px-4 py-3 text-red-600 text-sm font-manrope" data-testid="admin-login-error">
              {error}
            </div>
          )}

          <button
            data-testid="admin-login-btn"
            type="submit"
            disabled={loading || !password}
            className="w-full bg-[#1E3A8A] text-white rounded-full px-8 py-4 font-manrope font-medium hover:bg-[#172554] active:scale-[0.98] transition-all disabled:opacity-40 shadow-[0_4px_14px_rgba(30,58,138,0.3)] mt-2"
          >
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
